import { type BookingStatsCardProps } from "./getBookingStatsCardProps";

/**
 * Derives the empty state headline based on booking stats card props.
 *
 * - Tier 1 (significant matching activity, status=success, no referral CTA):
 *   "Shifts in your area are fully booked right now"
 * - Tier 2 (activity but no matching quals, status=success, referral CTA):
 *   "No {primaryQualification} shifts in your area"
 * - Tier 3 (no activity, status=warning):
 *   "No shifts in your area"
 */
export function getEmptyStateHeadline(
  bookingStatsCardProps: BookingStatsCardProps,
  primaryQualification?: string
): string {
  if (bookingStatsCardProps.status === "warning") {
    return "No shifts in your area";
  }

  if (bookingStatsCardProps.hasMatchingActivity) {
    return "Shifts in your area are fully booked right now";
  }

  if (primaryQualification) {
    return `No ${primaryQualification} shifts in your area`;
  }

  return "No shifts in your area";
}
